






















import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Routes } from '@/router/routes'
import PopupMenu from '@/components/shipment/PopupMenu.vue'
import ShipmentPoint from '@/dto/deliveries/ShipmentPoint'
import ShipmentPointsGroup from '@/dto/deliveries/ShipmentPointsGroup'
import shipmentStore from '@/stores/ShipmentStore'
import { isSingleCountry } from '@/services/shipmentPointLabel'

@Component({
  components: { PopupMenu },
})
export default class ShipmentListItems extends Vue {
  @Prop(Object)
  group: ShipmentPointsGroup

  shipmentStore = shipmentStore

  get shipmentPointId() {
    return this.shipmentStore.shipmentPointId as number
  }

  // Страна с единственной точкой → показываем страну вместо города.
  label(point: ShipmentPoint): string {
    return isSingleCountry(this.group)
      ? this.group.countryName
      : point.city.name
  }

  selectShipmentPoint(shipmentPointId: number) {
    this.$router.push({
      name: Routes.deliveries,
      params: { shipmentPointId: shipmentPointId.toString() },
    })
  }
}
